// extracted by mini-css-extract-plugin
export default {"slideFadeInDropdown":"MultilingualDropdown_slideFadeInDropdown__AgpgZ","slideFadeOutDropdown":"MultilingualDropdown_slideFadeOutDropdown__6HC77"};